<template>
	<div class="commonPageSty materialsEditPage">
		<sidebar :sidebarType="sidebarType" :sidebarPath="sidebarPath"></sidebar>

		<div class="commonPageRigSty">
			<!-- <div class="commonPageTitle">
				编辑材料
			</div> -->

			<customBreadcrumb :breadcrumbs="breadcrumbs" :cacheObj="cacheObj"></customBreadcrumb>

			<div class="commonPageRigBottomSty">
				<el-form @submit.native.prevent :model="formData" ref="formDataRef" :rules="rules" inline
					class="formBloSty formBloStyNoBorder" label-width="auto" label-position="left"
					hide-required-asterisk>
					<div class="commonPageBack displayF16Center justifyConB">
						<!-- <div class="displayF alignItemsC paddingTB8">
							<div class="fontWeightB fontSize18 lineHeight18 color_FFF">
								{{formData.title || '-'}}
							</div>
							<div class="fontSize16 color_B9B">
								（{{formData.number || '-'}}）
							</div>
						</div> -->
						<div class="displayF16Center widthPercentage">
							<div class="labelButtonBloSty">{{formData.number ? '编辑' : ''}}</div>

							<el-form-item label="" prop="title" class="maxWidth874 widthPercentage">
								<el-input ref="inputFocusRef" v-model="formData.title" placeholder="请填写材料标题"></el-input>
							</el-form-item>
						</div>

						<div class="displayF flexShrink0">
							<el-form-item v-if="typeVal == 'general'" label="材料类型" prop="typeId">
								<el-select v-model="formData.typeId" placeholder="请选择" clearable class="input224">
									<el-option v-for="item in typeIdData" :key="item.id" :label="item.name"
										:value="item.id" />
								</el-select>
							</el-form-item>

							<el-form-item label="到期时间" prop="expireTime">
								<div class="positionR">
									<el-date-picker @change="dateChange" type="date" format="YYYY-MM-DD"
										:editable="false" value-format="YYYY-MM-DD" v-model="formData.expireTime"
										placeholder="请选择" class="input224" />

									<div v-if="!isChange" class="expireTimeStr positionA lineHeight32 top0 color_FFF">
										{{formData.expireTimeStr}}
									</div>
								</div>
							</el-form-item>
						</div>
					</div>

					<div class="commonPageBack marginBottom24 positionR minHeight" style="padding-bottom: 80px;">
						<div class="commonPageSmallTitle">
							材料凭证
						</div>

						<div class="picHeightBloSty">
							<div class="displayF16Center paddingB8">
								<!-- <el-upload class="logoUploaderBig imgWH250 marginBottom16"
									:action="defaultSettings.systemLinkApi + 'sys/file/upload/file'"
									:on-success="handleSuccess" :show-file-list="false" :data="uploadData"
									:headers="uploadData">
									<el-icon>
										<Plus class="imgWH40" />
									</el-icon>
								</el-upload> -->

								<commonUpload v-if="picUrlData.length < 6" :dataObj="{
									uploadData,
									paramsData,
									pageType: 'materialsEdit'
								}" @handleSuccess="handleSuccess" @realTimeProgressPercentHandle="realTimeProgressPercentHandle">
								</commonUpload>

								<div v-for="(item, i) in picUrlData" :key="i"
									class="displayF16Center positionR marginBottom16 imgWH250">
									<div class="imgWH250 displayF alignItemsC justifyConC borderRadius4 overflowH "
										:class="isImageMethods(item.url) ? '' : getFileBack(item.url)">
										<img :src="isImageMethods(item.url) ? item.url : initThemeImg(theme, getFileType(item.url))"
											class="objectFitC maxWidthPercentage maxHeightPercentage" />
									</div>

									<div class="fileMessBloSty">
										<div class="nameSty">
											<elTooltipCommon
												:data="item.originalName ? switchFileText(item.originalName.split('.')[0]) : '-'"
												:dataRef="'originalName' + i"></elTooltipCommon>

											<div>
												{{item.originalName ? switchFileText(item.originalName.split('.')[1]) : ''}}
											</div>
										</div>

										<div class="contentSty">
											<div>
												<span>占用</span>空间：{{formatBytes(item.capacity) || '-'}}
											</div>

											<div>
												<!-- :class="item.url && isGetPermission() ? '' : 'opacity05'" -->
												<img @click="downHandle(item)"
													:src="initThemeImg(theme, 'icon_down@2x')" alt="">
												<!-- :class="isGetPermission() ? '' : 'opacity05'" -->
												<img @click="removeHandle(i, 'pic')"
													:src="initThemeImg(theme, 'icon_remove@2x')" alt="">
											</div>
										</div>
										<div>
											<span>提交</span>时间：{{!item.updateTime && !item.uploadTime ? '-' : ((item.updateTime ? item.updateTime.substring(2, 19) : '') || (item.uploadTime ? item.uploadTime.substring(2, 19) : '')) }}
										</div>
									</div>
								</div>
							</div>

							<!-- <div v-if="fileUrlData.length > 0" class="displayF16Center paddingB8 flexWrap">
								<div v-for="(item, i) in fileUrlData" :key="i"
									class="fileMessBloSty width250 marginBottom16">
									<div class="nameSty">
										<div class="ellipsisSty">
											{{item.originalName ? switchFileText(item.originalName.split('.')[0]) : '-'}}
										</div>
										<div>
											{{item.originalName ? switchFileText(item.originalName.split('.')[1]) : ''}}
										</div>
									</div>

									<div class="contentSty">
										<div>
											占用空间：{{formatBytes(item.capacity) || '-'}}
										</div>

										<div>
											<img @click="downHandle(item)" :src="initThemeImg(theme, 'icon_down@2x')"
												alt="" :class="item.url && isGetPermission() ? '' : 'opacity05'">
											<img @click="removeHandle(i, 'file')"
												:src="initThemeImg(theme, 'icon_remove@2x')" alt=""
												:class="isGetPermission() ? '' : 'opacity05'">
										</div>
									</div>
									<div>
										提交时间：{{item.updateTime || '-'}}
									</div>
								</div>
							</div> -->
						</div>

						<div class="commonPageSmallTitle">
							凭证描述
						</div>

						<Editor ref="editorRef" :modelValue="formData.describe" :obj="formData"
							@update:modelValue="newVal => formData.describe = newVal" class="archiveEditor">
						</Editor>

						<div class="buttonBlo buttonBloP buttonBloLeft">
							<el-button @click="submitHandle()" type="primary" :loading="loading">
								{{getSureText('保存')}}
							</el-button>

							<el-button @click="removeMaterialsHandle('single')" type="danger">删除单页</el-button>

							<el-button @click="removeMaterialsHandle()" type="danger">删除所有</el-button>

							<el-button @click="goBackCommonHandle('', cacheObj)">取消</el-button>

							<!-- 20260302 注释原按钮逻辑 -->
							<!-- :class="isGetPermission() ? '' : 'opacity05'" -->
							<!-- <div class="left" @click="submitHandle()">{{getSureText('保存')}}</div>
							<el-button @click="removeMaterialsHandle('single')" type="danger">删除单页</el-button>
							<el-button @click="removeMaterialsHandle()" type="danger">删除所有</el-button>
							<div class="rig" @click="goBackCommonHandle('', cacheObj)">取消</div> -->
						</div>
					</div>
				</el-form>
			</div>
		</div>

		<!-- 二次确认删除 -->
		<tipAdvertModal v-if="removeModalShow" :text="text" :tips="tips" :loadingReset="loadingReset"
			@sureHandle="removeSure" @cancelHandle="removeModalShow = false"></tipAdvertModal>
		<!-- 上传文件时 点击返回时提醒弹窗 -->
		<uploadBackTipsModal v-if="uploadTipsModalShow" :propsObj="commonModalObj" @cancelHandle="cancel()"
			@sureHandle="uploadTipsSure()"></uploadBackTipsModal>
	</div>
</template>

<script setup>
	import defaultSettings from '@/settings'
	import sidebar from '@/components/sidebar'
	import useUserStore from '@/store/modules/user'
	import {
		getIsImg,
		getSureText,
		getFileBack,
		getFileType,
		formatBytes,
		initThemeImg,
		beforeUpload,
		switchFileText,
		isImageMethods,
		setMessageQueue,
		isGetPermission,
		getNotEditableShow,
		goBackCommonHandle,
		globalCacheSaveApi,
		fileDownloadFileUrlApi,
		globalCacheSaveWhereNowApi
	} from '@/utils/common'
	import {
		Plus
	} from '@element-plus/icons-vue'

	import {
		archiverecordUpdateMaterial,
		archiverecordtypeAllType,
		archiverecordNextPage,
		archiverecordDelete
	} from '@/api/archivePage'

	// 主题色--默认亮色
	const theme = computed(() => {
		return useUserStore().theme
	})
	const configData = computed(() => {
		return useUserStore().archiveConfigData
	})
	// 配置数据
	const userConfigData = computed(() => {
		return useUserStore().userConfigData
	})

	const {
		proxy
	} = getCurrentInstance()
	const route = useRoute()
	const router = useRouter()
	const query = route.query
	const typeVal = query.type // type: general综合档案 member成员档案
	const pageType = query.pageType // pageType:accountMess memberArchive
	const materialsNumber = query.number
	const sidebarType = pageType === 'accountMess' ? 'myMess' : 'archive'
	const sidebarPath = pageType === 'accountMess' ? '/accountMessPage' : (typeVal == 'general' ? '/generalArchive' : (
		typeVal == 'member' ? '/memberArchive' : '/expirationWarning'))

	const formData = ref({
		expireTime: '',
		fileIds: []
	})
	const uploadData = ref({
		type: typeVal == 'general' ? 'overall_archive' :
		'member_archive', // 类型：member_archive（成员档案） overall_archive（综合档案）
		token: localStorage.getItem('token')
	})
	// 前置保存参数
	const paramsData = {
		moduleName: '档案库',
		functionName: typeVal == 'general' ? '综合档案' : '成员档案',
		skipParameter: '/materialsEdit' + window.location.search // 跳转路由参数
	}

	const picUrlData = ref([]) // 图片数组（+文件）
	// const fileUrlData = ref([]) // 文件数组
	const rules = {
		title: [{
			required: true,
			message: '请输入标题',
			trigger: ['change', 'blur']
		}],
		typeId: [{
			required: true,
			message: '请选择材料类型',
			trigger: ['change', 'blur']
		}]
	}
	const typeIdData = ref([]) // 材料类型数据
	const rowId = ref('')
	const sort = ref(query.sort)
	const isChange = ref(false) // 是否修改了到期时间
	const removeModalShow = ref(false) // 删除弹窗
	const text = ref('') // 删除文案
	const tips = ref('')
	const breadcrumbs = ref([{
		name: query.name,
		path: '',
	}])
	const cacheObj = ref(null)
	const uploadTipsModalShow = ref(false) // 上传中提醒弹窗
	const fileName = ref(null) // 上传文件名称
	const progressPercent = ref(0) // 上传文件实时进度
	const commonModalObj = ref({})
	const loadingReset = ref(false) // 20260302 新增 报错时重置loading状态 报错时true/false提交时
	const loading = ref(false)

	// 获取提醒弹窗显示状态 0返回 1保存
	function getCommonModalShow(index) {
		// 上传中
		console.log(progressPercent.value, 'progressPercent.value')
		if (progressPercent.value && progressPercent.value !== 100) {
			uploadTipsModalShow.value = true
			commonModalObj.value = {
				index, // 0 返回 1保存
				progress: progressPercent.value,
				fileName: fileName.value,
				tipsTitle: '保存'
			}

			return true
		}

		return false
	}

	// 上传提醒弹窗 确定 （1保存 0返回） 此过程中不管是否上传完成 直接调用提交接口
	function uploadTipsSure() {
		// 20260304 新增 报错时重置loading状态
		loadingResetMethods(false)
		
		if (progressPercent.value && progressPercent.value !== 100) {
			progressPercent.value = 0
		}
		
		// 保存--提交
		submitHandle()
	}

	// 实时进度返回
	function realTimeProgressPercentHandle(val, name) {
		progressPercent.value = val
		fileName.value = name || ''
		commonModalObj.value.progress = val
		console.log(progressPercent.value, fileName.value, 'realTimeProgressPercentHandle')
	}
	
	function cancel() {
		uploadTipsModalShow.value = false
	}
	
	// 20260304 新增 报错时重置loading状态 报错时true/false提交时
	function loadingResetMethods(val) {
		commonModalObj.value.loadingReset = val
	}
	
	// 修改了到期时间事件
	function dateChange() {
		isChange.value = true
	}

	// 点击下载
	async function downHandle(item) {
		// 非管理员 权限不足提示
		// if (!isGetPermission()) {
		// 	setMessageQueue('warning', '权限组不满足，无法操作')
		// 	return
		// }
		const data = await getNotEditableShow('', '', typeVal === 'general' ? 5 : 4)
		if (data.code === 505) {
			return
		}

		// if (typeVal === 'general') {
		// 	if (!configData.value.exportOverall) {
		// 		setMessageQueue('warning', '无法导出，综合档案导出许可关闭中')
		// 		return
		// 	}
		// } else {
		// 	if (!configData.value.exportMember) {
		// 		setMessageQueue('warning', '无法导出，成员档案导出许可关闭中')
		// 		return
		// 	}
		// }

		if (item.url) {
			// url文件下载开始接口
			fileDownloadFileUrlApi(item, '档案库', typeVal === 'general' ? '综合档案' : '成员档案')
			setMessageQueue('success', '已加入导出队列，详细查看‘导出记录’')
		} else {
			return
		}
	}

	// 点击删除单页/删除所有
	async function removeMaterialsHandle(single) {
		// 非管理员 权限不足提示
		// if (!isGetPermission()) {
		// 	setMessageQueue('warning', '权限组不满足，无法操作')
		// 	return
		// }
		
		// 20260330 新增许可权限校验 (9成员综合档案（包括材料）的删除)
		const data = await getNotEditableShow('', '', 9)
		if (data.code === 505) {
			return
		}

		removeModalShow.value = true
		text.value = '是否删除' + (single ? '当前' : '全部') + '材料页'
		tips.value = (single ? '材料页删除后无法恢复' : '该删除为材料内全部内容') + '，请谨慎操作。'
	}

	// 删除单页/删除所有
	function removeSure() {
		let single = text.value.indexOf('当前') > -1 ? true : false

		// 20260302 新增 报错时重置loading状态 报错时true/false提交时
		loadingReset.value = false

		archiverecordDelete({
			id: rowId.value,
			single
		}).then(res => {
			if (res) {
				setMessageQueue('success', single ? '材料页已删除' : '该材料全部内容已删除')
				if (single) {
					let pageNum = formData.value.pageNum
					if (pageNum === 1) {
						localStorage.setItem('submitType', 'addAndRemoveChild')
						// 公共返回方法
						goBackCommonHandle(-2, cacheObj.value)
					} else {
						let sortPage = localStorage.getItem('sortPage')
						if (pageNum == sortPage) {
							localStorage.setItem('sortPage', sortPage - 1)
						}
						localStorage.setItem('submitType', 'editChild')
						// 公共返回方法
						goBackCommonHandle('', cacheObj.value)
					}
				} else {
					localStorage.setItem('submitType', 'addAndRemoveChild')
					// 公共返回方法
					goBackCommonHandle(-2, cacheObj.value)
				}
			}
		}).catch(e => {
			// 20260302 新增 报错时重置loading状态 报错时true/false提交时
			loadingReset.value = true
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 删除
	async function removeHandle(index, type) {
		// 非管理员 权限不足提示
		// if (!isGetPermission()) {
		// 	setMessageQueue('warning', '权限组不满足，无法操作')
		// 	return
		// }
		const data = await getNotEditableShow('', '', 1)
		if (data.code === 505) {
			return
		}

		// if (type === 'pic') {
		picUrlData.value.splice(index, 1)
		// } else {
		// 	fileUrlData.value.splice(index, 1)
		// }
	}

	// 上传成功
	function handleSuccess(data) {
		console.log(data, 'handleSuccess')
		// let isImage = false
		// let imgData = ['.bmp', '.gif', '.jpeg', '.png', '.jpg']
		// for (let i = 0; i < imgData.length; i++) {
		// 	if (data.originalName.indexOf(imgData[i]) > -1) {
		// 		isImage = true
		// 	}
		// }
		// if (isImage) {
		picUrlData.value.push(data)
		// } else {
		// 	fileUrlData.value.push(data)
		// }
	}

	// 点击保存
	async function submitHandle() {
		// 非管理员 权限不足提示
		// if (!isGetPermission()) {
		// 	setMessageQueue('warning', '权限组不满足，无法操作')
		// 	return
		// }
		
		// 获取提醒弹窗显示状态 创建时调用
		if (getCommonModalShow(1)) {
			return
		}
		
		const data = await getNotEditableShow('', '', 1)
		if (data.code === 505) {
			return
		}

		proxy.$refs.formDataRef.validate(valid => {
			if (valid) {
				let form = formData.value
				let arr = []
				if (picUrlData.value.length > 0) {
					picUrlData.value.map(item => {
						arr.push(item.id)
					})
				}
				// if (fileUrlData.value.length > 0) {
				// 	fileUrlData.value.map(item => {
				// 		arr.push(item.id)
				// 	})
				// }
				if (arr.length === 0 && (!form.describe || form.describe == '<p><br></p>')) {
					setMessageQueue('warning', '无法添加，内容为空的材料页')
					return
				}

				form.fileIds = arr
				console.log(form, 'archiverecordAddMaterialApi')

				if (loading.value) {
					return
				}

				loading.value = true

				// 编辑材料接口
				archiverecordUpdateMaterialApi()
			} else {
				// 20260304 新增 报错时重置loading状态
				loadingResetMethods(true)
				
				return false
			}
		})
	}

	// 编辑材料接口
	function archiverecordUpdateMaterialApi() {
		archiverecordUpdateMaterial(formData.value).then(res => {
			if (res) {
				localStorage.setItem('submitType', 'editChild')
				setMessageQueue('success', '成功保存材料内容')
				// 公共返回方法
				goBackCommonHandle('', cacheObj.value)
				loading.value = false
			}
		}).catch(e => {
			// 20260304 新增 报错时重置loading状态
			loadingResetMethods(true)
			loading.value = false
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 综合档案--新建材料--获取材料类型列表
	function archiverecordtypeAllTypeApi() {
		archiverecordtypeAllType().then(res => {
			if (res) {
				let data = res.data
				typeIdData.value = data
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 获取第一条材料数据  删除单页后再次刷新页面目前会提示数据不存在（正常现象）
	function getDetails(init) {
		archiverecordNextPage({
			number: query.number,
			sort: !init ? (sort.value === formData.value.pageNum ? 1 : sort.value) : query.sort
		}).then(res => {
			if (res) {
				let data = res.data
				formData.value = data
				rowId.value = data.id
				sort.value = data.sort

				let picId = []
				let picData = []
				let fileData = []
				let ids = []
				// picUrlData.value = []
				// fileUrlData.value = []
				// if (data.fileList.length > 0) {
				// 	for (let i = 0; i < data.fileList.length; i++) {
				// 		let obj = data.fileList[i]
				// 		// 获取是否是图片
				// 		if (getIsImg(obj.originalName)) {
				// 			picData.push(obj)
				// 		} else {
				// 			fileData.push(obj)
				// 		}
				// 	}
				// }
				console.log(picData, 'picData fileData', fileData)
				picUrlData.value = data.fileList || []
				// picUrlData.value = picData
				// fileUrlData.value = fileData
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 设置当前所在位置(点击菜单时删除对应的详情路径缓存数据)
	async function getGlobalCacheSaveWhereNowApi(cacheType) {
		const routeData = await globalCacheSaveWhereNowApi(route.path.replace('/', ''), sidebarPath)
		console.log(routeData, 'globalCacheSaveWhereNowApi')

		if (routeData.code === 200) {
			cacheObj.value = {
				redirectPath: window.location.pathname + window.location.search,
				cacheType,
				level: 2,
				queryType: typeVal === 'general' ? 'material' : '',
				queryId: query.number
			}
			console.log(window.location.origin, window.location.pathname, 'details')
			// 保存详情页路径缓存
			globalCacheSaveApi(cacheObj.value)
		}
	}

	// 监听键盘shift+enter快捷键保存
	const handleKeyDown = (e) => {
		let shortcutModelArr = userConfigData.value.shortcutModelArr

		// 20260303 新增 弹窗时禁用
		if (useUserStore().isModal) {
			return
		}

		// shift+enter快捷键保存
		if (e.shiftKey && e.key === 'Enter') {
			if (shortcutModelArr.includes(1)) {
				e.preventDefault();
				// 直接调用保存
				submitHandle()
				e.stopPropagation();
			}
		} else if (document.activeElement && e.key === 'Tab') {
			// 目前获取焦点并且点击tab时
			if (document.activeElement.placeholder && document.activeElement.placeholder.includes('标题')) {
				proxy.$refs.editorRef.commonFocus()
			} else {
				// 标题默认获取焦点
				getInitFocus()
			}

			console.log(document.activeElement.placeholder, 'document.activeElement')
		}
	};

	// 标题默认获取焦点
	function getInitFocus() {
		setTimeout(() => {
			if (proxy.$refs.inputFocusRef) {
				proxy.$refs.inputFocusRef.focus()
			}
		}, 200)
	}

	onBeforeUnmount(() => {
		window.removeEventListener('keydown', handleKeyDown, true);
	});

	onMounted(() => {
		let cacheType = ''
		if (typeVal === 'general') {
			cacheType = 'overall_archive'
			// 综合档案--新建材料--获取材料类型列表
			archiverecordtypeAllTypeApi()
		} else if (typeVal === 'member') {
			cacheType = 'member_archive'
		} else {
			cacheType = 'waring_archive'
		}
		// 获取第一条材料数据
		getDetails('init')

		useUserStore().sidebarType = pageType === 'accountMess' ? 'myMess' : 'archive'

		// 获取档案配置
		useUserStore().configarchiveInfoApi()

		// 设置当前所在位置(点击菜单时删除对应的详情路径缓存数据)
		getGlobalCacheSaveWhereNowApi(cacheType)

		window.addEventListener('keydown', handleKeyDown, true);
	})
</script>

<style lang="scss" scoped>
	@import "@/styles/handle.scss";

	.formBloSty .el-form-item--default:last-child {
		margin-right: 0 !important;
	}

	.displayF {
		display: flex;
	}

	.expireTimeStr {
		left: 112px;
	}

	.el-button {
		font-size: 12px;
	}

	.el-button+.el-button {
		margin-left: 0;
	}

	.commonPageRigBottomSty .minHeight {
		min-height: calc(100vh - 206px);
	}

	:deep(.input224 .el-input__wrapper) {
		padding: 0 12px !important;
	}

	:deep(.el-input__prefix) {
		width: 24px !important;
	}

	.maxWidth874 {
		max-width: 874px;
	}
</style>